export default {
      id: "sli-empty-bookmark-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#sli-empty-bookmark",
      toString: function () {
        return this.url;
      }
    }